<template>
    <div class="VolunteerTableItem">
        <div class="VolunteerTableItem__rating">
            <div class="tableCell">
                <img v-if="rank<=3&&rank>0" :src="`/local/templates/main/img/icons/rang-${rank}.svg`" alt="">
                <span v-else>{{ rank }}</span>
            </div>
        </div>
        <div class="VolunteerTableItem__user">
            <div class="tableCell">
                <a :href="url">
                    <img :src="icon.src" :alt="icon.alt" :title="icon.title">
                </a>
            </div>
        </div>
        <div class="VolunteerTableItem__statsMobile">
            {{ translates.projects }} {{ projectsCount }} / {{ translates.hours }} {{ hoursCount }}
        </div>
        <div class="VolunteerTableItem__tags">
            <div class="tableCell">
                <ABadge v-for="(tag, key) in tags" :key="key">{{ tag }}</ABadge>
            </div>
        </div>
        <div class="VolunteerTableItem__stats">
            <div class="tableCell">{{ projectsCount }}</div>
        </div>
        <div class="VolunteerTableItem__stats">
            <div class="tableCell">{{ hoursCount }}</div>
        </div>
        <div class="VolunteerTableItem__link">
            <div class="tableCell">
                <a :href="url" class="nounderline">
                    <ABtn class="flat" color="var(--c-primary-200)" :label="translates.watch"/>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import {inject} from "vue";
import {ABadge, ABtn} from "../ui";

export default {
    name: "VolunteerTableItem",
    props: {
        rank: Number,
        icon: String,
        name: String,
        tags: Array,
        projectsCount: Number,
        hoursCount: Number,
        url: String
    },
    components: {
        ABadge,
        ABtn
    },
    setup(props) {
        const translates = inject('translates', {})

        return {
            translates
        }
    }
}
</script>

<style scoped lang="scss">
.VolunteerTableItem {
    position: relative;
    display: table-row;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;

    @include mobile {
        display: grid;
        padding: 0 26px;
        margin-bottom: 8px;
    }

    & > div {
        display: table-cell;
        vertical-align: middle;
    }

    &__rating, &__user {

        img {
            width: 60px;
            height: 60px;
            object-fit: cover;
            border-radius: 60px;
        }
    }

    &__user {
        @include mobile {
            padding-right: 80px;
        }
    }

    &__rating {
        @include mobile {
            position: absolute;
            top: 0;
            right: 25px;
        }

        > div {
            justify-content: center;
        }
    }

    &__link {
        @include tablet {
            display: none !important;
        }

        > div {
            justify-content: flex-end;
            padding-right: 35px;
        }
    }

    &__stats {
        @include mobile {
            display: none !important;
        }
    }

    &__statsMobile {
        display: none !important;
        font-weight: 400;

        @include mobile {
            display: flex !important;
        }
    }
}

.tableCell {
    height: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 20px 0;


    ::v-deep .a-badge {
        margin-right: 10px;
      margin-top: 5px;
      margin-bottom: 5px;
    }
}
</style>